__turbopack_context__.v({
  "absolute": "box-module-scss-module__aPqOtW__absolute",
  "align-flex-end": "box-module-scss-module__aPqOtW__align-flex-end",
  "align-flex-start": "box-module-scss-module__aPqOtW__align-flex-start",
  "align-space-around": "box-module-scss-module__aPqOtW__align-space-around",
  "align-space-between": "box-module-scss-module__aPqOtW__align-space-between",
  "background-step-almost-black": "box-module-scss-module__aPqOtW__background-step-almost-black",
  "background-step-amethyst": "box-module-scss-module__aPqOtW__background-step-amethyst",
  "background-step-before-midnight": "box-module-scss-module__aPqOtW__background-step-before-midnight",
  "background-step-black": "box-module-scss-module__aPqOtW__background-step-black",
  "background-step-black-v2": "box-module-scss-module__aPqOtW__background-step-black-v2",
  "background-step-coal-mine-canary": "box-module-scss-module__aPqOtW__background-step-coal-mine-canary",
  "background-step-coal-mine-canary-down": "box-module-scss-module__aPqOtW__background-step-coal-mine-canary-down",
  "background-step-cold-steel": "box-module-scss-module__aPqOtW__background-step-cold-steel",
  "background-step-cyanora": "box-module-scss-module__aPqOtW__background-step-cyanora",
  "background-step-cyanora-down": "box-module-scss-module__aPqOtW__background-step-cyanora-down",
  "background-step-dark-grey": "box-module-scss-module__aPqOtW__background-step-dark-grey",
  "background-step-dark-text": "box-module-scss-module__aPqOtW__background-step-dark-text",
  "background-step-diagonal-gradient-midnight-haze-to-black": "box-module-scss-module__aPqOtW__background-step-diagonal-gradient-midnight-haze-to-black",
  "background-step-future-fuscia": "box-module-scss-module__aPqOtW__background-step-future-fuscia",
  "background-step-future-fuscia-down": "box-module-scss-module__aPqOtW__background-step-future-fuscia-down",
  "background-step-light-text": "box-module-scss-module__aPqOtW__background-step-light-text",
  "background-step-linear-gradient-cyanora-to-future-fuscia": "box-module-scss-module__aPqOtW__background-step-linear-gradient-cyanora-to-future-fuscia",
  "background-step-midnight": "box-module-scss-module__aPqOtW__background-step-midnight",
  "background-step-negative": "box-module-scss-module__aPqOtW__background-step-negative",
  "background-step-off-white": "box-module-scss-module__aPqOtW__background-step-off-white",
  "background-step-positive": "box-module-scss-module__aPqOtW__background-step-positive",
  "background-step-right-before-black": "box-module-scss-module__aPqOtW__background-step-right-before-black",
  "background-step-right-before-midnight": "box-module-scss-module__aPqOtW__background-step-right-before-midnight",
  "background-step-secondary-text": "box-module-scss-module__aPqOtW__background-step-secondary-text",
  "background-step-vertical-gradient-cyanora-to-future-fuscia": "box-module-scss-module__aPqOtW__background-step-vertical-gradient-cyanora-to-future-fuscia",
  "background-step-warning": "box-module-scss-module__aPqOtW__background-step-warning",
  "background-step-white": "box-module-scss-module__aPqOtW__background-step-white",
  "box": "box-module-scss-module__aPqOtW__box",
  "column": "box-module-scss-module__aPqOtW__column",
  "column-reverse": "box-module-scss-module__aPqOtW__column-reverse",
  "fixed": "box-module-scss-module__aPqOtW__fixed",
  "grow": "box-module-scss-module__aPqOtW__grow",
  "justify-flex-end": "box-module-scss-module__aPqOtW__justify-flex-end",
  "justify-flex-start": "box-module-scss-module__aPqOtW__justify-flex-start",
  "justify-space-around": "box-module-scss-module__aPqOtW__justify-space-around",
  "justify-space-between": "box-module-scss-module__aPqOtW__justify-space-between",
  "pad-bottom": "box-module-scss-module__aPqOtW__pad-bottom",
  "pad-horizontal": "box-module-scss-module__aPqOtW__pad-horizontal",
  "pad-left": "box-module-scss-module__aPqOtW__pad-left",
  "pad-right": "box-module-scss-module__aPqOtW__pad-right",
  "pad-top": "box-module-scss-module__aPqOtW__pad-top",
  "pad-vertical": "box-module-scss-module__aPqOtW__pad-vertical",
  "relative": "box-module-scss-module__aPqOtW__relative",
  "rounded": "box-module-scss-module__aPqOtW__rounded",
  "row": "box-module-scss-module__aPqOtW__row",
  "row-reverse": "box-module-scss-module__aPqOtW__row-reverse",
  "shadow": "box-module-scss-module__aPqOtW__shadow",
  "shrink": "box-module-scss-module__aPqOtW__shrink",
  "static": "box-module-scss-module__aPqOtW__static",
  "sticky": "box-module-scss-module__aPqOtW__sticky",
  "with-background-image": "box-module-scss-module__aPqOtW__with-background-image",
});
